import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor() {}

  get symbol() {
    return '₴';
  }

  get name() {
    return 'грн';
  }

  formatMoney(money: number) {
    const moneyFormatted = this._format(money, 2, 3, ' ', '.');
    return moneyFormatted;
    return `${this.symbol} ${moneyFormatted}`;
  }

  /**
   * Number.prototype.format(n, x, s, c)
   *
   * @param integer n: length of decimal
   * @param integer x: length of whole part
   * @param mixed   s: sections delimiter
   * @param mixed   c: decimal delimiter
   */
  private _format = function (val, n, x, s, c) {
    if (val === null || val == undefined || val === '') {
      return '';
    }

    if (isNaN(val)) {
      return '';
    }

    val = +val;

    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = val.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(
      new RegExp(re, 'g'),
      '$&' + (s || ',')
    );
  };

  // 12345678.9.format(2, 3, '.', ',');  // "12.345.678,90"
  // 123456.789.format(4, 4, ' ', ':');  // "12 3456:7890"
  // 12345678.9.format(0, 3, '-');       // "12-345-679"
}
